import SetTranditionalRaffleWinnerSelect from "./setTranditionalRaffleWinnerSelect.container";

export default SetTranditionalRaffleWinnerSelect;
